export default "__VITE_ASSET__1c033e6e__"